export default "__VITE_ASSET__6c9815e7__"